module.exports = {
  METADATA: {
    TITLE: 'How to start a podcast',
    DESCRIPTION:
      "Podcasting doesn't have to be as complicated as you think! Here's everything you need to get started.",
  },
};
